
// componente para mostrar la lista de llamadas pendientes


// components importation
import { Close, PencilSquareIcon } from "../../components/icons/AppIcons.jsx";


// global function import
import { renderDate } from "../../global-functions/global-functions.js";


// language importation
import { LANGUAGE } from "../../config/appConf.js";

// import useTranslation
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { CommentBox } from "./CommentBox.jsx";







export const ListPendingServ = ({ list = [], onClose }) => {

  const [t] = useTranslation("global");

  // state definition
  const [state, setState] = useState({ showData: true, id: 0 });

  // funcion para manejar el comentario
  const handleComment = (id = 0) => {
    setState((val) => ({ ...val, id, showData: !state.showData }));
  };

  return (
    <div className="background-modal">
      <div className="cont-lst-serv-pend">
        <div className="modal-header">
          <h4>{t("NewCallComp.llamadas_abiertas")} ({list.length})</h4>

          <button type="button" className="btn-close" onClick={onClose}>
            <Close width="19" height="19" />
          </button>
        </div>
        <div className="modal-body">
          {
            !state.showData && (
              <CommentBox id={state.id} onClose={handleComment} />
            )
          }
          {
            state.showData && (
              <>
                <h5 className="row-flex gap-small">{t("NewCallComp.comentario_llamada")} <PencilSquareIcon /></h5>
                {
                  // table mobile
                  window.screen.width > 990 && (
                    <div className="m-y-small">

                      <table className="table">
                        <thead className="table-head">
                          <tr>
                            <th>Ticket no.</th>
                            <th>{t("NewCallComp.equipment")}</th>
                            <th>{t("NewCallComp.ingresado_por")}</th>
                            <th>{t("NewCallComp.fecha")}</th>
                            <th>{t("NewCallComp.falla")}</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody className="table-body">
                          {
                            list && list.map((serv) => (
                              <tr key={serv.CodServicio}>
                                <td>{serv.CodServicio}</td>
                                <td>{serv.Equipo}</td>
                                <td>{serv.Nombre}</td>
                                <td></td>
                                <td>{serv.Problema}</td>
                                <td>
                                  <button type="button" className="btn-comment" onClick={() => handleComment(serv.CodServicio)}>
                                    <PencilSquareIcon />
                                  </button>
                                </td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>

                    </div>
                  )
                }

                {
                  window.screen.width <= 990 && (
                    <div className="cont-mob-cards-serv-lst flex-col">
                      {
                        list && list.map((serv) => (
                          <div className="card-mobile-lst-serv" key={serv.CodServicio}>
                            <div className="row-flex">
                              <div className="col-mb-30 p-col">
                                <strong>Ticket No.</strong>
                              </div>
                              <div className="col-mb-80 p-col">
                                <strong className="fake-link-2">
                                  {serv.CodServicio}
                                </strong>
                              </div>
                            </div>

                            <div className="row-flex">
                              <div className="col-mb-30 p-col">
                                <strong>{t("NewCallComp.equipment")}</strong>
                              </div>
                              <div className="col-mb-80 p-col">
                                <span>{serv.Equipo}</span>
                              </div>
                            </div>

                            <div className="row-flex">
                              <div className="col-mb-30 p-col">
                                <strong>{t("NewCallComp.ingresado_por")}</strong>
                              </div>
                              <div className="col-mb-80 p-col">
                                <span>{serv.Nombre}</span>
                              </div>
                            </div>

                            <div className="row-flex">
                              <div className="col-mb-30 p-col">
                                <strong>{t("NewCallComp.falla")}</strong>
                              </div>
                              <div className="col-mb-80 p-col">
                                <span>{serv.Problema}</span>
                              </div>
                            </div>

                            <div className="row-flex">
                              <div className="col-mb-30 p-col">
                                <strong>{t("NewCallComp.fecha")}</strong>
                              </div>
                              <div className="col-mb-80 p-col">
                                <span>{renderDate(serv.FecIngreso, LANGUAGE)}</span>
                              </div>
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  )
                }
              </>
            )
          }
        </div>
      </div>
    </div>
  );
};